
export enum ReportOPEEnum {
  PutUserReport = 'putUserReport',
  GetUserReports = 'getUserReports',
  DelUserReport = 'delUserReport',
  ExecUserReport = 'execUserReport'
}
